var _effectorFileName = "/src/shared/components/logo/logo.tsx";
import Link from 'next/link';
import { useRouter } from 'next/router';
import LogoEnDarkIcon from '@/shared/components/icons/logo/en/logo-dark';
import LogoEnLightIcon from '@/shared/components/icons/logo/en/logo-light';
import LogoRuDarkIcon from '@/shared/components/icons/logo/ru/logo-dark';
import LogoRuLightIcon from '@/shared/components/icons/logo/ru/logo-light';
import { DEFAULT_LOCALE, Locale } from '@/shared/config/i18n';
export const Logo = () => {
  const router = useRouter();
  const currentLocale = (router.locale ?? DEFAULT_LOCALE) as Locale;
  const isRu = currentLocale === 'ru';
  return <Link aria-label="Go to main page" href="/" prefetch={false}>
      {isRu ? <>
          <LogoRuDarkIcon className="hidden h-6 w-auto text-black dark:block sm:h-5 md:h-10" />
          <LogoRuLightIcon className="block h-6 w-auto text-black dark:hidden sm:h-5 md:h-10" />
        </> : <>
          <LogoEnDarkIcon className="hidden h-6 w-auto text-black dark:block sm:h-5 md:h-10" />
          <LogoEnLightIcon className="block h-6 w-auto text-black dark:hidden sm:h-5 md:h-10" />
        </>}
    </Link>;
};